
import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { MaterialMasterService } from 'src/app/services/material-master.service';

@Component({
  selector: 'app-assembly-for-access',
  templateUrl: './assembly-for-access.component.html',
  styleUrls: ['./assembly-for-access.component.css']
})
export class AssemblyForAccessComponent implements ICellEditorAngularComp, AfterViewInit {
  private params: any;
  public selectedValues: any[] = [];
  public options: any[] = [];
  public selectAllState: 'checked' | 'unchecked' | 'indeterminate' = 'unchecked';

  Standdata: any;
  cellWidth: number = 80;

  @ViewChild(MatSelect) matSelect: MatSelect;

  constructor(
    private materialService: MaterialMasterService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  agInit(params: any): void {
    this.params = params;

    const configurationId =
      this.params.node.data.ConfigurationName?.ConfigurationId ??
      this.params.node.data.ConfigurationId;

    this.cellWidth = params?.column?.actualWidth || 80;

    this.materialService.GetAllTCAssemblyForAccess(configurationId).subscribe(
      (res: any) => {
        const errorMsg = res?.Data?.Message;
        if (res?.StatusCode === 200) {
          this.Standdata = res.Data;

          // Normalize the options into consistent object references
          // If the service returns strings, keep them as strings; if it returns objects, use their AssemblyName
          this.options = (this.Standdata || []).map((el: any) => {
            const name = typeof el === 'string' ? el : (el?.AssemblyName ?? el);
            return { AssemblyName: name };
          });

          // Build initial selections using grid cell data (robust to string/object shapes)
          const initial = (params.data.Assemblies || []).map((a: any) => {
            const name = typeof a === 'string' ? a : (a?.AssemblyName ?? a);
            return this.options.find(opt => opt.AssemblyName === name);
          }).filter(Boolean);

          // Use the same references as in options
          this.selectedValues = initial;

          this.updateSelectAllState();

          // Open the dropdown
          setTimeout(() => this.matSelect?.open(), 0);
        } else {
          const errorContainer = [
            { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
            { [serverMessage.message + errorMsg]: serverMessage.serverErrorHeader }
          ];
          this.openAlertDialog(errorContainer);
        }
      },
      (_err) => {
        this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }]);
      }
    );
  }

  /** Compare by AssemblyName to keep object identity irrelevant */
  compareItems(item1: any, item2: any): boolean {
    return !!item1 && !!item2 && item1.AssemblyName === item2.AssemblyName;
  }

  /** Returns true when all options are selected */
  isAllSelected(): boolean {
    return (
      Array.isArray(this.selectedValues) &&
      this.options.length > 0 &&
      this.selectedValues.length === this.options.length &&
      this.options.every(opt => this.selectedValues.some(sel => this.compareItems(opt, sel)))
    );
  }

  /** Update the tri-state of the "Select All" pseudo checkbox */
  updateSelectAllState(): void {
    if (!Array.isArray(this.selectedValues) || this.selectedValues.length === 0 || this.options.length === 0) {
      this.selectAllState = 'unchecked';
    } else if (this.isAllSelected()) {
      this.selectAllState = 'checked';
    } else {
      this.selectAllState = 'indeterminate';
    }
  }

  /** Click handler for the "Select All" option */
  toggleSelectAll(): void {
    const allSelected = this.isAllSelected();
    this.selectedValues = allSelected ? [] : [...this.options];

    // Reflect state immediately
    this.updateSelectAllState();
    this.cdr.detectChanges();
  }

  /**
   * Use ngModelChange to get the full updated array in one shot.
   * This avoids race conditions you can get with (selectionChange) per-option events.
   */
  onModelChange(values: any[]): void {
    // Keep only valid option references from the options list (defensive)
    const byName = new Map(this.options.map(o => [o.AssemblyName, o]));
    this.selectedValues = (values || [])
      .map(v => byName.get(v?.AssemblyName))
      .filter(Boolean);

    this.updateSelectAllState();
    this.cdr.detectChanges();
  }

  openAlertDialog(error: any): void {
    this.dialog.open(AlertDialogComponent, { data: error });
  }

  getValue(): any {
    return this.selectedValues;
  }

  onOpenedChange(opened: boolean): void {
    if (!opened) {
      this.params.api.stopEditing();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.matSelect?.open(), 0);
  }

  isPopup(): boolean {
    return true;
  }
}
